import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

import { ReactComponent as QuoteSvg } from '~media/aws/quote.svg'
import grid from '~media/aws/grid.svg'

export default function AWSQuoteGraphic({ variation, ...rest }) {
  const theme = useTheme()

  return (
    <div
      css={[
        {
          position: 'relative',

          '&::after': {
            content: "''",
            position: 'absolute',
            background: `url(${grid}) no-repeat center center`,
            backgroundSize: 'contain',
            width: '100%',
            height: '100%',
            left: '-15%',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: -1,
          },
        },

        variation === 'small' && {
          maxWidth: 300,
          margin: '0 auto',
        },
      ]}
      {...rest}
    >
      <QuoteSvg
        css={{
          [theme.mq.small__max]: {
            maxWidth: 300,
            margin: '0 auto',
            display: 'block',
          },
        }}
      />
    </div>
  )
}

AWSQuoteGraphic.propTypes = {
  variation: PropTypes.oneOf(['small']),
}
